/** @format **/

import { generateScreen } from "./generator";

const personScreens = (i18n) => ({
  email: {
    type: "email",
    params: {
      collectBlackbox: true,
    },
  },

  fullName: {
    type: "full-name",
    flowConfirmation: {
      groupId: "name",
      editId: "maiden-name",
      orderNo: 2,
      labelLocale: () => i18n.t("fullName:full_name"),
    },
    params: {
      conditions: [
        {
          property: "app.country.code",
          value: "JP",
          not: true,
        },
        {
          property: "app.country.code",
          not: true,
          value: ["DE"],
        },
      ],
    },
  },

  firstName: {
    type: "first-name",
    flowConfirmation: {
      orderNo: 1,
      labelLocale: () => i18n.t("firstName:first_name"),
    },
  },

  lastName: {
    type: "last-name",
    flowConfirmation: {
      orderNo: 1,
      labelLocale: () => i18n.t("lastName:last_name"),
    },
  },

  firstNameJP: {
    type: "first-name.japan",
    params: {
      conditions: [{ property: "app.country.code", value: "JP" }],
    },
  },

  lastNameJP: {
    type: "last-name.japan",
    params: {
      conditions: [{ property: "app.country.code", value: "JP" }],
    },
  },

  personalPassword: {
    type: "personal-password",
    params: {
      conditions: [
        {
          property: "socialMediaData.socialSignIn",
          value: false,
        },
        {
          property: "user.reactivated",
          value: false,
        },
      ],
    },
  },

  passwordWarning: {
    type: "password-warning",
    params: {
      passwordScreenPath: "/chapter1/personal-password",
      conditions: [
        {
          property: "user.reactivated",
          value: false,
        },
      ],
    },
  },

  nationality: {
    type: "nationality",
    flowConfirmation: {
      labelLocale: () => i18n.t("flowConfirmation:nationality"),
      orderNo: 7,
      propertyName: "nationality",
    },
  },

  birthPlace: {
    type: "birth-place.germany",
    params: {
      title: () => i18n.t("birthplace:title"),
      placeholder: (store) => i18n.t("birthplace:placeholder"),
      currentAnswer: (store) =>
        (store.state.user.birthplace && store.state.user.birthplace.city) || "",
      isNested: true,
      nestedProperty: "city",
      dispatchKey: "updateUser",
      propertyName: "birthplace",
      validation: true,
    },
    flowConfirmation: {
      labelLocale: () => i18n.t("flowConfirmation:birthplace"),
      orderNo: 5,
      propertyName: "birthplace.city",
    },
  },

  bsn: {
    type: "open-question.bsn",
    params: {
      title: () => i18n.t("regulated:bsn.title"),
      placeholder: (store) => i18n.t("regulated:bsn.placeholder"),
      currentAnswer: (store) => store.state.user.bsn,
      dispatchKey: "updateUser",
      propertyName: "bsn",
      validation: true,
    },
    flowConfirmation: {
      propertyName: "bsn",
      orderNo: 6,
      labelLocale: () => i18n.t("flowConfirmation:bsn"),
      editId: "bsn",
    },
  },

  gender: {
    type: "question.gender",
    params: {
      columns: true,
      text: () => i18n.t("gender:select_gender"),
      dispatchKey: "updateUser",
      propertyName: "gender",
      showKeyboardOnNextScreen: false,
      currentAnswer: (store) => store.state.user.gender,
      answers: () => [
        { id: "female", label: i18n.t("gender:female") },
        { id: "male", label: i18n.t("gender:male") },
      ],
    },
  },

  maidenName: {
    type: "question.maiden-name",
    params: {
      columns: true,
      text: () => i18n.t("specifics:maiden_name_question.title"),
      hint: () => i18n.t("specifics:maiden_name_question.hint"),
      dispatchKey: "updateUser",
      showKeyboardOnNextScreen: true,
      propertyName: "hasChangedMaidenName",
      currentAnswer: (store) => store.state.user.hasChangedMaidenName,
      answers: () => [
        { id: true, label: i18n.t("base:yes") },
        { id: false, label: i18n.t("base:no") },
      ],
    },
  },

  openMaidenName: {
    type: "open-question.maiden-name",
    params: {
      title: () => i18n.t("specifics:maiden_name.title"),
      placeholder: (store) => i18n.t("specifics:maiden_name.placeholder"),
      currentAnswer: (store) => store.state.user.maidenName,
      dispatchKey: "updateUser",
      propertyName: "maidenName",
      validation: true,
    },
    flowConfirmation: {
      labelLocale: () => i18n.t("flowConfirmation:maiden-name"),
      propertyName: "maidenName",
      orderNo: 3,
    },
  },

  reactivationPersonalPassword: {
    type: "personal-password.reactivation",
    params: {
      conditions: [
        {
          property: "socialMediaData.socialSignIn",
          value: false,
        },
        {
          property: "user.reactivated",
          value: true,
        },
      ],
    },
  },

  reactivationPasswordWarning: {
    type: "password-warning.reactivation",
    params: {
      passwordScreenPath: "/chapter3/personal-password-reactivation",
      conditions: [
        {
          property: "user.reactivated",
          value: true,
        },
      ],
    },
  },
});

export const getInternationalFullName = (i18n) => {
  const screens = [
    { name: "firstName" },
    { name: "lastName" },
    { name: "lastNameJP" },
    { name: "firstNameJP" },
    { name: "fullName" },
  ];

  return generateScreen(personScreens, { i18n, screens });
};

export const getPersonScreens = generateScreen.bind(null, personScreens);



// WEBPACK FOOTER //
// ./src/partners/config/screens/person.js